'use client';

import { useEffect, useState } from 'react';

/** "updated 12 s ago", ticking once a second. Renders the static ISO time
 *  until mounted so server and client markup agree; after that the relative
 *  string takes over. `iso` changes whenever the parent's poll succeeds. */
export default function UpdatedAgo({
  iso,
  prefix = 'updated',
  className = 'text-dim',
}: {
  iso: string;
  prefix?: string;
  /** Colour override — the staleness label needs amber, not dim. */
  className?: string;
}) {
  const [now, setNow] = useState<number | null>(null);

  useEffect(() => {
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const then = new Date(iso).getTime();
  let text: string;
  if (now === null || !Number.isFinite(then)) {
    text = `${prefix} ${iso.replace('T', ' ').slice(0, 19)} UTC`;
  } else {
    const s = Math.max(0, Math.round((now - then) / 1000));
    text = s < 60 ? `${prefix} ${s} s ago` : s < 3600 ? `${prefix} ${Math.floor(s / 60)} min ago` : `${prefix} ${Math.floor(s / 3600)} h ago`;
  }
  return (
    <span className={`whitespace-nowrap font-jetbrains text-[12px] tabular-nums ${className}`} aria-live="off">
      {text}
    </span>
  );
}
